<template>
  <div class="sm_star">
    <div :class="{ sm_content_fade: showPopup }">
      <TopAppBar :leftBtnMode="leftBtnMode" :rightBtnMode="rightBtnMode" :title="title" :leftBtnMethod="leftBtnMethod"
        :rightBtnMethod="rightBtnMethod" ref="top_app_bar"></TopAppBar>

      <!-- content -->
      <div class="sm_content">
        <!-- 배너 -->
        <MainBanner :isBannerLoading="isBannerLoading" :bannerList="bannerList" />

        <div class="sm_wrap">
          <div class="sm_position">
            <!-- 유저 프로필 -->
            <MainUserProfile :memberData="memberData" :memberPoints="memberPoints" :memberRank="memberRank"
              :responsibilityName="responsibilityName" :dutyName="dutyName" />

            <!-- 퀵메뉴 -->
            <MainQuickMenu />

            <!-- 검색창 -->
            <div class="search-input" @click="goToSearch">
              <!-- <button class="search_btn"></button> -->
              <button class="mdc-button search_btn__input">
                <i class="material-icons search_icon">search</i>
              </button>
              <input class="search-input__input" :placeholder="$t('S20052')" />
            </div>

            <!-- 게시글 -->
            <div class="sm_post">
              <!-- 공지 Notice -->
              <dl class="post_dl" v-if="noticeList && noticeList.length > 0">
                <dt class="notice-title-wrapper">
                  <div class="dt-title">{{ noticeBoard.name }}</div>
                  <div class="dt-subTitle" @click="moveToNotice">
                    {{ $t("S20053") }}
                  </div>
                </dt>
                <div class="notice-wrapper">
                  <div v-for="(notice, i) in noticeList" :key="i" class="notice-box"
                    @click="moveToNoticeDetail(notice)">
                    <div class="notice-box__html" v-html="listFilter(notice.contents.subject)" />
                  </div>
                </div>
              </dl>

              <!-- 최근 본 게시글 -->
              <dl class="post_dl" v-if="recentViewList && recentViewList.length > 0">
                <dt class="dt-title">{{ $t("S10012") }}</dt>
                <div class="vertical-scroll-wrapper">
                  <div v-for="(data, i) in recentViewList" :key="i" class="recent-box" @click="moveToDetail(data)">
                    <div class="recent-box-title">{{ data.name }}</div>
                    <div class="recent-box-other" style="">
                      <div class="recent-box-middle">
                        <div class="recent-box-name">
                          <span style="color: #acb4be">by </span>
                          {{
                            data.teacher &&
                              data.teacher.name &&
                              data.teacher.name.fullName
                              ? data.teacher.name.fullName
                              : ""
                          }}
                        </div>
                        <div class="recent-box-progress__text">
                          {{ data.progression }} %
                        </div>
                      </div>
                      <div class="recent-box-progressbar">
                        <div class="recent-box-progressbar__bar" :style="`width: ${data.progression}%;`"></div>
                      </div>
                    </div>
                  </div>
                </div>
              </dl>

              <!-- New Contents 5items -->
              <MainContentCard v-if="contentNewStudyList && contentNewStudyList.length > 0" :data="contentNewStudyList"
                :title="$t('S20054')" @moveToDetail="moveToDetail" />

              <!-- New e-Learning 5items -->
              <MainContentCard v-if="elearningNewStudyList && elearningNewStudyList.length > 0"
                :data="elearningNewStudyList" :title="$t('S20055')" @moveToDetail="moveToDetail" />
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- popup -->
    <div class="sm_content1 popup_content" :class="{ hide_content: !showPopup }"
      v-if="popupData && popupData.length > 0">
      <!-- <div class="header-div">
        <div class="head-text t-center">
          <div class="text">{{ $t("1890") }}</div>
        </div>
      </div> -->
      <div class="sm_visual1" @click="redirectOnPage(popupData[currentPopup])">
        <img class="popup-img" v-if="popupData[currentPopup]" :src="popupData[currentPopup].image.resourceUri" alt="" />
      </div>
      <div class="sm_wrap popup_checkbox" v-if="popupData.length == currentPopup + 1">
        <div class="sm_position">
          <div class="mdc-form-field">
            <div class="mdc-checkbox">
              <input type="checkbox" class="mdc-checkbox__native-control" id="checkbox-1" v-model="checkBox" />

              <div class="mdc-checkbox__background">
                <svg class="mdc-checkbox__checkmark" viewBox="0 0 24 24">
                  <path class="mdc-checkbox__checkmark-path" fill="none" d="M1.73,12.91 8.1,19.28 22.79,4.59" />
                </svg>
                <div class="mdc-checkbox__mixedmark"></div>
              </div>

              <div class="mdc-checkbox__ripple"></div>
            </div>
            <label for="checkbox-1">{{ $t("S10041") }} </label>
          </div>
        </div>
      </div>
      <div class="mgt-7 popup_button" style="padding: 0px 16px 5px 16px">
        <button @click.prevent="closePopup" class="w-full mdc-button mdc-button--raised btn-red btn-big custom-btn">
          {{ $t("3065") }}
          <!-- 로그인  -->
        </button>
      </div>
    </div>

    <!-- Star Radar Floating Button -->
    <div class="fixed-bottom-icon bg-mainBtn shadow1 pdr-18 pdl-18 pdt-17 pdb-17" @click="goToWrite()"
      v-if="boardData.boardAuth">
      <img src="@/assets/icon_Radar.svg" class="w-24 h-24" />
      <span class="d-inline-block pdl-8 t-color-white t-nowrap t-body2">{{
        $t("S10055")
        }}</span>
    </div>
  </div>
</template>

<script>
import "swiper/dist/css/swiper.css";
import { swiper, swiperSlide } from "vue-awesome-swiper";

import mainApi from "@/api/mainApi.js";
import popupApi from "@/api/popupApi.js";
import radarApi from "@/api/radarApi.js";
import campaignApi from "@/api/campaignApi.js";

import { topAppBarMixin } from "@/mixins/topAppBar.js";

import { captureApiError } from "@/utils/sentryApiHandler.js";
import { MAIN_BANNER_CONSTANTS } from "@/utils/constants/mainBannerConstants";

import TopAppBar from "@/components/TopAppBar.vue";

import MainContentCard from "./MainContentCard.vue";
import MainBanner from "./MainBanner.vue";
import MainUserProfile from "./MainUserProfile.vue";
import MainQuickMenu from "./MainQuickMenu.vue";

export default {
  name: "Main",

  data() {
    return {
      responsibilityName: "",
      dutyName: "",
      categoryDataContent: null,
      categoryData: null,
      memberData: null,
      recentData: null,
      newVideoTalkData: null,
      recentLearningData: null,
      recentContentData: null,
      eLearning: null,
      categoryData1: null,
      isCompaignImage: false,
      compaignImage: null,
      dynamicLinkImage: null,
      post_box_recent_char: null,
      post_box_video_char: null,
      post_box_recentcont_char: null,
      post_box_recentlearning_char: null,
      popupData: null,
      responseData: null,
      checkBox: false,
      popupDataLength: 0,
      currentPopup: 0,
      showPopup: false,
      memberPoints: null,
      memberRank: null,
      boardData: {},
      myId: null,
      selectedChild: null,
      boardId: "BOARD1",
      boardList: null,
      specificIds: JSON.parse(process.env.VUE_APP_CONTENTS_IDX),

      // recent view
      recentViewList: [],

      // new Study List
      contentNewStudyList: [],
      elearningNewStudyList: [],

      // notice
      noticeList: [],
      noticeBoard: null,

      // banner
      isBannerLoading: true, // 배너 로딩 상태
      bannerList: [],
    };
  },

  components: {
    TopAppBar,
    MainContentCard,
    swiper,
    swiperSlide,
    MainBanner,
    MainUserProfile,
    MainQuickMenu,
  },

  mixins: [topAppBarMixin],

  computed: {
    // swiper define
    swiper() {
      return this.$refs.mySwiper.swiper;
    },
  },

  beforeRouteLeave(to, from, next) {
    if (!(sessionStorage.getItem("popupRedirect1") == "yes")) {
      return next();
    } else if (
      to.path == "/login" ||
      to.path == "/member/changepassword" ||
      to.path == "/popup"
    ) {
      window.history.forward();
    } else {
      return next();
    }
  },

  created() {
    this.loadBanner();
  },

  mounted() {
    //checking token from native
    this.setTopAppBarHomeBlank();
    this.fetchData();
    this.checkPopupToDisplay();
    // Updated By Jungnam.lee@emcast.com 2022-05-27 Voc Hide
    this.checkBoardAuth();
  },

  methods: {
    async loadBanner() {
      this.isBannerLoading = true; // 로딩 시작
      try {
        const bannerResult = await campaignApi.getMainPageCampaign();
        if (bannerResult && bannerResult.data.data) {
          this.bannerList = bannerResult.data.data.images;
        }
      } catch (error) {
        console.error("Failed to fetch banner list:", error);
      } finally {
        this.isBannerLoading = false;
      }
    },

    async fetchData() {
      try {
        const itemCount = 5;
        const [
          categoryResult,
          fetchMemberResult,
          recentViewResult,
          existsResult,
        ] = await Promise.all([
          mainApi.fetchGroupCategory(),
          mainApi.fetMember(),
          mainApi.fetchRecentView({ itemCount }),
          mainApi.fetchNotice(),
        ]);
        if (fetchMemberResult && fetchMemberResult.data.data) {
          this.memberData = fetchMemberResult.data.data;
          this.memberPoints = this.memberData.point
            .toString()
            .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
          this.memberRank =
            this.memberData.ranking && this.memberData.ranking.rank
              ? this.memberData.ranking.rank
                .toString()
                .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
              : "";
        }

        if (
          recentViewResult &&
          recentViewResult.data.data &&
          recentViewResult.data.data.length > 0
        ) {
          this.recentViewList = recentViewResult.data.data;
        }

        if (existsResult && existsResult.data.data) {
          try {
            const noticeResult = await mainApi.fetchArticles({ itemCount: 3 });
            this.noticeList = noticeResult.data.data.articles;
            this.noticeBoard = noticeResult.data.data.board;
            localStorage.setItem(
              "noticeBoardData",
              JSON.stringify(noticeResult.data.data.board)
            );
          } catch (noticeError) {
            console.log("Error Notice Result : ", noticeError);
            captureApiError({
              err: noticeError,
              frontRoute: this.$route,
              frontData: this.$data,
            });
          }
        } else {
          localStorage.setItem("noticeBoardData", JSON.stringify(false));
        }

        if (categoryResult && categoryResult.data.data) {
          const contentGroupCategory = categoryResult.data.data[0];
          const eLearningGroupCategory = categoryResult.data.data[1];

          const contentGroupCategoryId = contentGroupCategory
            ? contentGroupCategory.groupCategory.id
            : "1";
          const eLearningGroupCategoryId = eLearningGroupCategory
            ? eLearningGroupCategory.groupCategory.id
            : "2";

          sessionStorage.setItem(
            MAIN_BANNER_CONSTANTS.CONTENTS,
            JSON.stringify(contentGroupCategoryId)
          );
          sessionStorage.setItem(
            MAIN_BANNER_CONSTANTS.E_LEARNING,
            JSON.stringify(eLearningGroupCategoryId)
          );

          const categoryParams = contentGroupCategory.parentCategories
            .map((category) => `&categories=${category.id}`)
            .join("");
          const categoryNotInParams = eLearningGroupCategory.parentCategories
            .map((category) => `&categories=${category.id}`)
            .join("");
          const [contentNewStudyResult, elearningNewStudyResult] =
            await Promise.all([
              mainApi.fetchNewStudyList(categoryParams),
              mainApi.fetchNewStudyList(categoryNotInParams),
            ]);
          this.contentNewStudyList = contentNewStudyResult.data.data;
          this.elearningNewStudyList = elearningNewStudyResult.data.data;
        }
        console.log("MAIN PAGE FETCH DATA SUCCESS");
      } catch (mainError) {
        console.log("MAIN PAGE FETCH DATA ERROR : ", mainError);
        captureApiError({
          err: mainError,
          frontRoute: this.$route,
          frontData: this.$data,
        });
      }
    },

    checkPopupToDisplay() {
      let popupTime = localStorage.getItem("popupTime");
      let currentTimeStamp = new Date().getTime();

      if (!popupTime || currentTimeStamp - popupTime > 86400000) {
        if (!sessionStorage.getItem("popupRedirect1")) {
          this.$showLoading();
          popupApi
            .fetpopupDetail()
            .then((response) => {
              this.popupData = response.data.data;
              this.popupDataLength = this.popupData.length;

              let resData = this.popupData;
              if (
                resData.length > 0 &&
                resData[0].postStart < currentTimeStamp &&
                resData[0].postEnd > currentTimeStamp
              ) {
                this.$hideLoading();
                this.showPopup = true;
              }
            })
            .catch((err) => {
              let responseData = err.response.data.meta;
              this.$error({ content: responseData.errMsg }).then(() => { });
              captureApiError({
                err,
                frontRoute: this.$route,
                frontData: this.$data,
              });
            });

          this.$hideLoading();
        }
      }
    },

    closePopup() {
      sessionStorage.setItem("popupRedirect1", "yes");
      if (this.currentPopup < this.popupDataLength - 1) {
        this.currentPopup++;
      } else {
        if (this.checkBox) {
          //save in local storage
          let popupTime = new Date().getTime();
          localStorage.setItem("popupTime", popupTime);
        }
        this.showPopup = false;
      }
    },

    listFilter(str) {
      let length = 120;
      let ending = " ...";
      let str1 = "";
      if (str.length > length) {
        str1 = str.substring(0, length - ending.length) + ending;
        return str1.replace(/(\r\n|\n|\r)/gm, "<br/>");
      } else {
        return str.replace(/(\r\n|\n|\r)/gm, "<br/>");
      }
    },

    redirectOnPage(popupObject) {
      sessionStorage.setItem("popupRedirect1", "yes");
      const popUpType = popupObject.linkType.value.toLowerCase();
      const linkSubType = popupObject.linkSubType
        ? popupObject.linkSubType.value
        : "";
      const linkIdx = popupObject.linkIdx * 1;
      switch (popUpType) {
        case "content":
        case "e_learning":
          const status = popUpType === "content" ? "CONTENTS" : "LEARNING";
          this.redirectToContent(status, linkIdx);
          break;
        case "forum":
          this.redirectToForum(
            linkSubType,
            popupObject.linkIdentifier,
            linkIdx
          );
          break;
        case "event":
          this.redirectToEvent(popupObject.linkIdentifier, linkIdx);
          break;
        case "survey":
          this.redirectToSurvey(linkSubType, linkIdx);
          break;
        case "star_radar":
          this.redirectToStarRadar(linkIdx);
          break;
        case "exam":
          this.redirectToExam();
          break;
        default:
          console.log("default popup link");
          break;
      }
    },

    redirectToContent(status, categoryId) {
      this.$router.push({
        name: "Learn",
        query: {
          status,
          category: categoryId.toString(),
        },
      });
    },

    redirectToForum(subType, bId, idx) {
      const routeName =
        subType === "LIST" ? "SocialLearning" : "SocialLearningView";
      this.$router.push({
        name: routeName,
        params: {
          postId: idx,
        },
        query: {
          bId,
        },
      });
    },

    redirectToSurvey(subType, id) {
      const routeName =
        subType === "LIST" ? "IndependentSurvey" : "IndependentSurveyTotalView";
      this.$router.push({
        name: routeName,
        params: {
          distId: id,
        },
      });
    },

    redirectToStarRadar(postId) {
      this.$router.push({
        name: "radarView",
        params: {
          postId,
        },
      });
    },

    redirectToEvent(board, id) {
      if (!id) {
        this.$router.push("/event");
      } else {
        this.$router.push({
          name: "EventDetail",
          params: {
            id,
          },
          query: {
            board: "BOARD1",
          },
        });
      }
    },

    redirectToExam() {
      this.$router.push({
        name: "IndependentExam",
      });
    },

    checkBoardAuth() {
      radarApi
        .getRadarBoardId()
        .then((res) => {
          radarApi
            .boardAuth(res.data.data.identifier)
            .then((response) => {
              this.boardData = response.data.data;
              radarApi
                .fetchMember()
                .then((response) => {
                  this.responsibilityName =
                    response.data.data.responsibilityName;
                  this.dutyName = response.data.data.dutyName;
                  let mamberDatas = response.data.data;
                  let myId = mamberDatas.responsibilityId;
                  this.myId = myId;
                  let permissionData = this.boardData.authPermission.find(
                    (child) => child.partId == myId
                  );
                  if (permissionData) {
                    this.selectedChild = permissionData;
                  }
                })
                .catch((err) => {
                  $state.error();
                  captureApiError({
                    err,
                    frontRoute: this.$route,
                    frontData: this.$data,
                  });
                });
            })
            .catch((err) => {
              $state.error();
              captureApiError({
                err,
                frontRoute: this.$route,
                frontData: this.$data,
              });
            });
        })
        .catch((err) => {
          console.log("GET RADAR BOARD ID err : ", err);
          $state.error();
          captureApiError({
            err,
            frontRoute: this.$route,
            frontData: this.$data,
          });
        });
    },

    //VOC Write
    goToWrite() {
      this.$router.push({
        name: "Radar",
      });
      // if(!this.boardData.boardAuth){
      //     this.$alert({
      //       content: this.$t("3064"),
      //       accept: this.$t("3065"),
      //     }).then(() => {})
      //       .catch(() => {});
      // } else {
      //
      // }
    },

    goToSearch() {
      this.$router.push({
        name: "Search",
      });
    },

    // // 설문 목록으로 이동
    // goToSurveyAll() {
    //   this.$router.push({
    //     name: 'IndependentSurvey',
    //   });
    // }

    moveToDetail(data) {
      this.$router.push({
        path: `learn/${data.id}`,
        query: {
          come: "HOME",
        },
      });
    },

    moveToNotice() {
      this.$router.push({
        name: "Notice",
        query: {
          bId: this.noticeBoard.identifier,
          id: this.noticeBoard.id,
        },
      });
    },

    moveToNoticeDetail(data) {
      this.$router.push({
        path: `/notice/${data.id}`,
        query: {
          bId: this.noticeBoard.identifier,
          come: "HOME",
        },
      });
    },
  },
};
</script>
<style type="text/css" scoped>
/* font */
@import url("//fonts.googleapis.com/css?family=Roboto:400,300,100,500,700");

/* reset */
.sm_star * {
  margin: 0;
  /* padding: 0; */
  font-family: "Roboto", Arial, dotum, sans-serif;
  font-weight: normal;
  font-size: 13px;
  color: #222;
}

ol,
ul,
li {
  list-style: none;
}

table {
  width: 100%;
  border-collapse: collapse;
  border-spacing: 0;
  table-layout: fixed;
}

th {
  font-weight: normal;
}

form,
fieldset,
iframe {
  display: block;
  border: 0;
}

img,
button {
  border: none;
  vertical-align: middle;
}

hr {
  height: 0;
  display: none;
}

i,
em,
address {
  font-style: normal;
}

label,
button {
  cursor: pointer;
}

blockquote,
q {
  quotes: none;
}

caption,
.hide {
  visibility: hidden;
  width: 0;
  height: 0;
  padding: 0;
  margin: 0;
  font-size: 0;
  text-indent: -9999em;
}

legend {
  overflow: hidden;
  visibility: hidden;
  position: absolute;
  width: 0;
  height: 0;
  padding: 0;
  margin: 0;
  font-size: 0;
  text-indent: -100%;
  white-space: nowrap;
  z-index: -1;
}

input[type="text"],
input[type="password"],
input[type="email"],
input[type="search"],
input[type="image"],
input[type="tel"],
textarea {
  -webkit-appearance: none;
  -webkit-border-radius: 0;
}

input:focus {
  outline: none;
}

::-webkit-input-placeholder {
  color: #999;
}

::-moz-selection {
  background: #005aab;
  color: #fff;
  text-shadow: none;
}

::-webkit-selection {
  background: #005aab;
  color: #fff;
  text-shadow: none;
}

a {
  color: #222;
  text-decoration: none;
}

a:link,
a:visited {
  text-decoration: none;
}

button {
  display: inline-block;
  background: none;
  border: none;
  outline: none;
}

::selection {
  background: #005aab;
  color: #fff;
  text-shadow: none;
}

/* style */
/* .sm_star{position:relative; margin:0 auto}
		.sm_header{position:fixed; left:0; top:0; width:100%; height:55px; border-bottom:1px solid #e9e9e9; z-index:999; background-color:#fff}
		.sm_header h1{text-align:center; color:#212121; font-size:18px; font-weight:500; height:55px; line-height:55px}
		.sm_header .menu_btn{width:55px; height:55px; position:absolute; left:0; top:0; font-size:0; text-align:center}
		.sm_header .menu_btn span{width:18px; height:2px; background:#2d6dcc; font-size:0; display:inline-block}
		.sm_header .menu_btn:after{width:18px; height:2px; background:#2d6dcc; content:''; position:absolute; left:50%; top:50%; transform:translate(-50%,-50%); margin-top:-5px}
		.sm_header .menu_btn:before{width:18px; height:2px; background:#2d6dcc; content:''; position:absolute; left:50%; top:50%; transform:translate(-50%,-50%); margin-top:5px} */

.sm_content {
  position: relative;
  padding-top: 55px;
  padding-bottom: 34px;
}

.sm_wrap {
  position: relative;
  margin: 0 15px;
}

.sm_wrap .sm_position {
  max-width: 768px;
  margin: 0 auto;
  position: relative;
}

.icon .sm_post {
  position: relative;
  padding: 20px 0 0 0;
}

.sm_post>dl {
  margin-bottom: 25px;
}

.sm_post>dl:nth-last-child(1) {
  margin-bottom: 0;
}

.post_dl {
  position: relative;
}

.dt-title {
  position: relative;
  font-size: 16px;
  font-weight: bold;
  color: #212121;
}

.dt-subTitle {
  margin-left: auto;
  color: #2d6dcc;
  font-size: 14px;
  line-height: 22px;
  font-weight: 500;
}

.post_dl dt .view {
  display: inline-block;
  color: #2d6dcc;
  font-size: 14px;
  font-weight: 500;
  position: absolute;
  right: 0;
  top: 0;
}

.post_dl dd {
  position: relative;
  padding: 5px 0 0 0;
}

.post_box {
  position: relative;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.2);
}

.post_box_252 {
  /* height: 252px */
  min-height: 228px;
}

.post_box_228 {
  min-height: 228px;
}

.post_box>a {
  display: block;
  position: relative;
}

.post_box .con {
  position: relative;
}

.post_box .visual {
  position: relative;
}

.post_box .visual img,
.post_box .visual video,
.post_box .visual iframe {
  width: 100%;
  display: block;
}

.post_box .visual .tag {
  display: inline-block;
  color: #fff;
  font-size: 10px;
  padding: 5px 10px;
  background: rgba(0, 0, 0, 0.2);
  position: absolute;
  left: 10px;
  top: 10px;
  border-radius: 25px;
}

.post_box .txt {
  position: relative;
  background: #fff;
  padding: 15px 15px;
  color: #505050;
  font-size: 16px;
  font-weight: 500;
}

.recent {
  position: relative;
  margin: 0 -15px;
  padding: 20px 15px 40px 15px;
  border-top: 1px solid #dcdcdc;
}

.post_box img {
  height: 185px;
  object-fit: cover;
}

/* popup */
.header-div {
  background: #313d4b;
  height: 56px !important;
  width: 100%;
}

.header-div .head-text {
  height: 29px;
  font-size: 20px;
  padding-top: 18px;
  color: #fffefe;
}

.sm_visual1 {
  height: 450px;
  width: 100%;
  overflow: auto;
}

.sm_content1 {
  background: white;
}

.sm_content1.popup_content {
  position: absolute;
  z-index: 99999;
  left: 0px;
  top: 0px;
  background: #504f4fbf;
  width: 95%;
  left: 2.5%;
  top: 37.5px;
}

.mgt-7.popup_button {
  padding-top: 5px !important;
  margin-top: 0px !important;
  background: white !important;
}

.sm_wrap.popup_checkbox {
  margin: 0px !important;
  background: white !important;
}

.mdc-form-field>label {
  padding-left: 20px !important;
}

.hide_content {
  display: none !important;
}

.text {
  font-size: 20px !important;
  color: #fffefe !important;
}

button.mdc-button.mdc-button--raised.btn-red.w-full.btn-big.custom-btn {
  font-weight: 500;
  font-size: 0.875rem;
  margin: 16px 0px !important;
}

.sm_content_fade {
  position: relative;
}

.sm_content_fade::before {
  content: "";
  position: absolute;
  left: 0;
  top: 0;
  background-color: #0e0d0dab;
  width: 100%;
  height: 100%;
  z-index: 9999;
  overflow: hidden;
}

/* @media (max-width: 320px) {
  .sm_star {
    padding-bottom: 2.5%;
    height: initial !important;
  } */

.pdt-114 {
  padding-top: 114px !important;
}

.search-input {
  border: 1px solid #2d6dcc;
  width: 100%;
  border-radius: 25px;
  background: transparent;
  position: relative;
  margin: 14px 0 24px 0;
}

.search-input__input {
  padding: 15px 25px;
  width: 100%;
  height: 100%;
  background: #fff;
  border: none;
  border-radius: 25px;
}

.search_btn {
  width: 50px;
  height: 100%;
  position: absolute;
  right: 5px;
  top: 0;
  font-size: 0;
  text-align: center;
  background: url(/images/search_btn.svg) center center no-repeat;
  background-size: 22px auto;
}

.search_btn__input {
  width: 50px;
  height: 100%;
  position: absolute;
  right: 5px;
  top: 0;
  font-size: 0;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
}

.search_icon {
  color: #2d6dcc;
  font-size: 20px;
}

.recent-box {
  min-width: 230px;
  max-width: 230px;
  min-height: 110px;
  max-height: 110px;
  height: 100%;

  padding: 14px;
  margin-right: 12px;

  position: relative;
  overflow: hidden;

  border-radius: 8px;
  background: #ffffff;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.2);

  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.recent-box-title {
  font-size: 14px;
  font-weight: 500;
  line-height: 16px;
}

.recent-box-middle {
  display: flex;
  margin-bottom: 8px;
}

.recent-box-name {
  font-size: 12px;
}

.recent-box-progress__text {
  margin-left: auto;
  font-size: 16px;
  font-weight: bold;
  letter-spacing: 1px;
  color: #2d6dcc;
}

.recent-box-progressbar {
  background: #ececee;
  height: 4px;
  width: 100%;
}

.recent-box-progressbar__bar {
  height: 100%;
  background-color: #2d6dcc;
}

.notice-title-wrapper {
  display: flex;
  margin-bottom: 10px;
}

.notice-box {
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.2);
  height: 60px;
  padding: 12px;
  border-radius: 8px;
  color: #505050;
  margin-bottom: 12px;
  background: #fff;
  display: flex;
  align-items: center;
}

.notice-box__html {
  word-break: break-word;
  text-overflow: ellipsis;
  overflow: hidden;
  -webkit-line-clamp: 2;
  display: -webkit-box;
  -webkit-box-orient: vertical;

  width: 100%;
  max-height: 100%;
  line-height: 18px;
}

.sm_user {
  position: relative;
  z-index: 1;
  border-radius: 8px;
  background: transparent;
  margin-top: -35px;

  display: flex;
  flex-direction: column;
  justify-content: center;
}
</style>
